import type { FC } from 'react';
import { Box, StepButton } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import useOrderSteps from 'src/hooks/useOrderSteps';
import { StepType } from 'src/types/step';

interface StepperProps {
  onStepClicked?: (step: StepType) => void;
  onNextStepClicked?: () => void;
  onPrevStepClicked?: () => void;
  onBack?: () => void;
}

const StepperComponent: FC<React.PropsWithChildren<StepperProps>> = ({ onNextStepClicked, onPrevStepClicked, onStepClicked }) => {

  const steps = useOrderSteps((state) => state.orderSteps);
  const activeStep = useOrderSteps((state) => state.currentOrderStep);

  const isLastStep = (): Boolean => {
    return activeStep === steps[steps.length - 1]?.step;
  };

  const renderSteps = (item: StepType, i: number) => {
    let activeStepClasses = activeStep === item.step ? 'active' : '';
    if (activeStep === 4) {
      return (
        <Step key={item.title} className={`step-group ${activeStepClasses}`}>
          <StepButton className="step-label" onClick={() => onStepClicked(item)}>
            {item.title}
          </StepButton>
        </Step>
      );
    } else {
      return (
        <Step key={item.title} className={`step-group ${activeStepClasses}`} disabled={i === 3}>
          <StepButton className="step-label" onClick={() => onStepClicked(item)}>
            {item.title}
          </StepButton>
        </Step>
      );
    }
  };

  return (
    <div className="stepper-container">
      {activeStep !== 1 && (
        <div className="stepper-component__btn-group-container">
          <Button onClick={onPrevStepClicked} className="btn-inverted stepper-component__btn-group__btn d-none d-xs-block">
            <ArrowBackIosIcon /> <span>Previous</span>
          </Button>
        </div>
      )}

      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={activeStep - 1} nonLinear={true}>
          {steps.reduce((acc, item, i) => {
            return [...acc, renderSteps(item, i)];
          }, [])}
        </Stepper>
        <div className="stepper-component__btn-group d-xs-none">
          {activeStep === 1 ? (
            ''
          ) : (
            <Button onClick={onPrevStepClicked} className="btn-inverted stepper-component__btn-group__btn">
              <ArrowBackIosIcon />
              <span>Previous</span>
            </Button>
          )}

          <Box sx={{ flex: '1 1 auto' }} />

          {!isLastStep() && (
            <Button onClick={onNextStepClicked} className="btn-inverted stepper-component__btn-group__btn">
              <ArrowForwardIosIcon />
              <span> Next</span>
            </Button>
          )}
        </div>
      </Box>

      {!isLastStep() && (
        <Button onClick={onNextStepClicked} className="btn-inverted d-none d-xs-block stepper-component__btn-group__btn">
          <span>Next</span> <ArrowForwardIosIcon />
        </Button>
      )}
    </div>
  );
};

export default StepperComponent;
